import { render, staticRenderFns } from "./VATWHTReport.vue?vue&type=template&id=3c858d71&scoped=true&"
import script from "./VATWHTReport.vue?vue&type=script&lang=js&"
export * from "./VATWHTReport.vue?vue&type=script&lang=js&"
import style0 from "./VATWHTReport.vue?vue&type=style&index=0&id=3c858d71&lang=scss&scoped=true&"
import style1 from "./VATWHTReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c858d71",
  null
  
)

export default component.exports